import { Box, IconButton, Paper, Typography, TextField, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, Button, Grid, Divider, Chip, OutlinedInput, Autocomplete, useMediaQuery, Slide, Dialog, DialogContent, DialogActions, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, DialogTitle } from '@mui/material'
import React, { forwardRef, useCallback, useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { app_title, endpoint } from '../../config'
import { ArrowBack, Edit as EditIcon, Add as AddIcon, CheckCircle as ActiveIcon, Cancel as InactiveIcon } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { customToast } from '../../lib/toastLib'
import { useTheme } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from '@mui/lab'
import DeleteIcon from '@mui/icons-material/Delete';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

export default function LenderEdit() {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const { t } = useTranslation();
	const navigate = useNavigate()
	const { lenderId } = useParams()
	const [lenderName, setLenderName] = useState("Loading...");
	const [loading, setLoading] = useState(true);
	const [originalData, setOriginalData] = useState({});
	const [lenderGroups, setLenderGroups] = useState([]);
	const [draggedItem, setDraggedItem] = useState(null);
	const [draggedOverItem, setDraggedOverItem] = useState(null);

	// Get ticket class and credit score class data from Redux store
	const ticketClass = useSelector((state) => state.smartList.ticketClass);
	const creditScoreClass = useSelector((state) => state.smartList.creditScoreClass);

	// State for form values
	const [formData, setFormData] = useState({
		incomeMin: '',
		incomeMax: '',
		ageMin: '',
		ageMax: '',
		ticketClass: '',
		creditScoreClass: '',
		salaried: false,
		selfEmployed: false,
		business: false,
		priority: '',
		lenderStatus: false,
		specialOffer: false,
		// Loan details
		loanAmountUpto: '',
		tenure: '',
		interestRate: '',
		monthlyPRMin: '',
		monthlyPRMax: '',
		processingFees: '',
		// KFS details
		kfs: '',
		// Special offer details
		soText: '',
		soDateStart: '',
		soDateEnd: '',
		// Lender Groups
		lenderGroupIds: [],
		autoSubmission: false,
		// Eligibility criteria details
		age_text: '',
		employment_text: '',
		income_text: '',
		min_loan_text: '',
		max_loan_text: '',
		cibil_text: '',
		lender_journey_text: '',
		mp4_text: '',
		pptx_text: '',
		pdf_text: ''
	})

	const [showRevenueModal, setShowRevenueModal] = useState(false);
	const [lenderRevenue, setLenderRevenue] = useState([]);
	const [revenueLoading, setRevenueLoading] = useState(false);
	const [revenueTypes, setRevenueTypes] = useState(new Map());
	const [revenueFormData, setRevenueFormData] = useState({
		slab_disbursed_min: '',
		slab_disbursed_max: '',
		slab_number_min: '',
		slab_number_max: '',
		ats_min: '',
		ats_max: '',
		revenue_type_id: '',
		revenue_flat: '',
		revenue_percentage: '',
		status: true
	});
	const [revenueErrors, setRevenueErrors] = useState({
		slab_disbursed_min: '',
		slab_disbursed_max: '',
		slab_number_min: '',
		slab_number_max: '',
		ats_min: '',
		ats_max: '',
		revenue_type_id: '',
		revenue_flat: '',
		revenue_percentage: '',
		status: ''
	});
	const [addingRevenue, setAddingRevenue] = useState(false);
	const [orderLoading, setOrderLoading] = useState(false);
	// Create a local theme to override z-index for menus
	const menuTheme = createTheme({
		components: {
			MuiPopover: {
				defaultProps: {
					container: document.body
				},
				styleOverrides: {
					paper: {
						zIndex: 9999
					}
				}
			},
			MuiMenu: {
				defaultProps: {
					container: document.body
				},
				styleOverrides: {
					paper: {
						zIndex: 9999
					}
				}
			}
		}
	});

	// Add these state variables after other state declarations
	const [deleteLoading, setDeleteLoading] = useState(false);
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [deleteItemId, setDeleteItemId] = useState(null);
	const [editingRevenueId, setEditingRevenueId] = useState(null);
	const fileInputRef = useRef(null);

	useEffect(() => {
		fetchLenderDetails();
		fetchLenderGroups();
		fetchRevenue();
		fetchRevenueTypes();
	}, [])

	const fetchLenderGroups = async () => {
		try {
			const response = await axios.get(`${endpoint}/api/lender-group/get-all`);
			if (response.data.success) {
				setLenderGroups(response.data.lenderGroups);
			}
		} catch (error) {
			console.error('Error fetching lender groups:', error);
			customToast.error("Failed to load lender groups");
		}
	}

	const fetchLenderDetails = async () => {
		try {
			setLoading(true);
			const response = await axios.get(`${endpoint}/api/get-lender-data/${lenderId}`)

			const lenderData = response.data;

			// Set lender name for display
			setLenderName(lenderData.name);

			// Store the original data for comparison
			setOriginalData(lenderData);

			// Map API response to form data
			setFormData({
				incomeMin: lenderData.min_income || '',
				incomeMax: lenderData.max_income || '',
				ageMin: lenderData.min_age || '',
				ageMax: lenderData.max_age || '',
				ticketClass: lenderData.ticket_class || '',
				creditScoreClass: lenderData.credit_score_class,
				salaried: Boolean(lenderData.salaried),
				selfEmployed: Boolean(lenderData.self_employed),
				business: Boolean(lenderData.business),
				priority: lenderData.priority || '0',
				lenderStatus: Boolean(lenderData.lender_status),
				specialOffer: Boolean(lenderData.so_status),
				// Loan details
				loanAmountUpto: lenderData.loan_amount_upto || '',
				tenure: lenderData.tenure || '',
				interestRate: lenderData.interest_rate || '',
				monthlyPRMin: lenderData.apr_min || '',
				monthlyPRMax: lenderData.apr_max || '',
				processingFees: lenderData.processing_fees || '',
				// KFS details
				kfs: lenderData.kfs || '',
				// Special offer details
				soText: lenderData.so_text || '',
				soDateStart: lenderData.so_date_start || '',
				soDateEnd: lenderData.so_date_end || '',
				// Lender Groups
				lenderGroupIds: lenderData.lender_group_ids || [],
				autoSubmission: Boolean(lenderData.autosubmission),
				// Eligibility criteria details
				age_text: lenderData.age_text || '',
				employment_text: lenderData.employment_text || '',
				income_text: lenderData.income_text || '',
				min_loan_text: lenderData.min_loan_text || '',
				max_loan_text: lenderData.max_loan_text || '',
				cibil_text: lenderData.cibil_text || '',
				lender_journey_text: lenderData.lender_journey_text || '',
				mp4_text: lenderData.mp4_text || '',
				pptx_text: lenderData.pptx_text || '',
				pdf_text: lenderData.pdf_text || ''
			});

			setLoading(false);
		} catch (error) {
			console.error('Error fetching lender details:', error);
			setLoading(false);
		}
	}

	const fetchRevenue = async () => {
		try {
			setRevenueLoading(true);
			const { data } = await axios.get(`${endpoint}/api/lender-revenue/get/${lenderId}`);
			setLenderRevenue(data.lenderRevenue);
		} catch (error) {
			console.error('Error fetching revenue:', error);
		} finally {
			setRevenueLoading(false);
		}
	}

	const fetchRevenueTypes = async () => {
		try {
			const { data } = await axios.get(`${endpoint}/api/lender-revenue/get-types`);
			if (data.success === "true") {
				const typeMap = new Map();
				data.data.forEach(type => {
					typeMap.set(type.id, type.name);
				});
				setRevenueTypes(typeMap);
			}
		} catch (error) {
			console.error('Error fetching revenue types:', error);
			customToast.error("Failed to load revenue types");
		}
	}

	const handleChange = (e) => {
		const { name, value } = e.target
		setFormData({
			...formData,
			[name]: value
		})
	}

	const handleSelectChange = (e) => {
		const { name, value } = e.target

		setFormData({
			...formData,
			[name]: value
		})

		// Get the API property name based on form field name
		const propertyMapping = {
			ticketClass: 'ticket_class',
			creditScoreClass: 'credit_score_class'
		};

		const apiPropertyName = propertyMapping[name];

		// If we have a mapping, update it immediately
		if (apiPropertyName) {
			updateField(apiPropertyName, value);
		}
	}

	const handleMultiSelectChange = (event, newValue) => {
		// Check if "Create Group Lender" option was selected
		const createOption = newValue.find(option => option.id === "create-new");

		if (createOption) {
			// Remove the "Create" option from the selection
			const filteredValue = newValue.filter(option => option.id !== "create-new");

			// Update actual selection without the "Create" option
			const selectedIds = filteredValue.map(group => group.id);
			setFormData({
				...formData,
				lenderGroupIds: selectedIds
			});

			// Open the modal
			setShowLenderGroupModal(true);
			setLenderGroupName("");
			return;
		}

		// Extract the IDs from the selected lender groups
		const selectedIds = newValue.map(group => group.id);

		setFormData({
			...formData,
			lenderGroupIds: selectedIds
		});

		// Update the API with the new selection
		updateField('lender_group_ids', selectedIds);
	}

	const handleCheckboxChange = (e) => {
		const { name, checked } = e.target
		setFormData({
			...formData,
			[name]: checked
		})

		// Get the API property name based on form field name
		const propertyMapping = {
			salaried: 'salaried',
			selfEmployed: 'self_employed',
			business: 'business',
			lenderStatus: 'lender_status',
			specialOffer: 'so_status',
			autoSubmission: 'autosubmission'
		};

		const apiPropertyName = propertyMapping[name];

		// If we have a mapping, update it immediately
		if (apiPropertyName) {
			updateField(apiPropertyName, checked ? 1 : 0);
		}
	}

	const handleDateChange = (e) => {
		const { name, value } = e.target

		setFormData({
			...formData,
			[name]: value
		})

		// Get the API property name based on form field name
		const propertyMapping = {
			soDateStart: 'so_date_start',
			soDateEnd: 'so_date_end'
		};

		const apiPropertyName = propertyMapping[name];

		// If we have a mapping, update it immediately
		if (apiPropertyName) {
			updateField(apiPropertyName, value);
		}
	}

	const handleBlur = (e) => {
		const { name, value } = e.target;

		// Get the API property name based on form field name
		const propertyMapping = {
			incomeMin: 'min_income',
			incomeMax: 'max_income',
			ageMin: 'min_age',
			ageMax: 'max_age',
			priority: 'priority',
			loanAmountUpto: 'loan_amount_upto',
			tenure: 'tenure',
			interestRate: 'interest_rate',
			monthlyPRMin: 'apr_min',
			monthlyPRMax: 'apr_max',
			processingFees: 'processing_fees',
			soText: 'so_text',
			age_text: 'age_text',
			employment_text: 'employment_text',
			income_text: 'income_text',
			min_loan_text: 'min_loan_text',
			max_loan_text: 'max_loan_text',
			cibil_text: 'cibil_text',
			lender_journey_text: 'lender_journey_text',
			mp4_text: 'mp4_text',
			pptx_text: 'pptx_text',
			pdf_text: 'pdf_text',
			kfs: 'kfs',
		};

		const apiPropertyName = propertyMapping[name];

		// If we have a mapping and the value has changed, update it
		if (apiPropertyName) {
			// Convert form value to the same type as original data for comparison
			let originalValue = originalData[apiPropertyName];
			let currentValue = value;

			// For numeric fields, ensure consistent type comparison
			if (typeof originalValue === 'number') {
				currentValue = currentValue === '' ? null : Number(currentValue);
			}

			// Only update if the value has changed
			if (originalValue !== currentValue) {
				updateField(apiPropertyName, currentValue);
			}
		}
	}

	const updateField = async (property, value) => {
		try {
			await axios.post(`${endpoint}/api/update-lender-data`, {
				lender_id: lenderId,
				property: property,
				value: value
			});

			// Update the original data to reflect the new value
			setOriginalData(prev => ({
				...prev,
				[property]: value
			}));

			customToast.success("Lender updated successfully!");
		} catch (error) {
			console.error('Error updating field:', error);

			// Revert the form data to the original value on error
			fetchLenderDetails();

			// Show error toast
			if (error.response) {
				customToast.error(error.response.data?.message || "Update failed");
			} else {
				customToast.error(error.message || "Update failed");
			}
		}
	}

	const handleAttachmentChange = async (e) => {
		try {
			// Check if a file was selected
			if (!e?.target?.files?.[0]) {
				return;
			}

			const file = e.target.files[0];
			const fieldName = e.target.name;

			// Create FormData for file upload
			const uploadFormData = new FormData();
			uploadFormData.append("image_name", file);
			uploadFormData.append("path", `${lenderName} - attachment`);

			// Upload file to S3
			const { data } = await axios.post(
				`${endpoint}/api/s3-upload-file`,
				uploadFormData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			);

			// Update form state with the uploaded file URL
			setFormData(prevFormData => ({
				...prevFormData,
				[fieldName]: data?.file
			}));
			updateField(fieldName, data?.file);
		} catch (error) {
			console.error("Error uploading file:", error);
			const message =
				error?.response?.data?.message || error?.message || "Failed to upload file";
			customToast.error(message);
		}
	}


	// Create Lender Group
	const [showLenderGroupModal, setShowLenderGroupModal] = useState(false);
	const [lenderGroupName, setLenderGroupName] = useState("");
	const [createLenderGroupLoading, setCreateLenderGroupLoading] = useState(false);

	const createLenderGroup = useCallback((e) => {
		e.preventDefault();

		setCreateLenderGroupLoading(true);
		axios.post(`${endpoint}/api/lender-group/create`, {
			name: lenderGroupName
		}).then((response) => {
			const newGroupId = response.data.lenderGroup.id;

			if (newGroupId) {
				const newGroup = { id: newGroupId, name: lenderGroupName };
				setLenderGroups(prev => [...prev, newGroup]);

				const updatedIds = [...formData.lenderGroupIds, newGroupId];
				setFormData(prev => ({
					...prev,
					lenderGroupIds: updatedIds
				}));

				updateField('lender_group_ids', updatedIds);
			} else {
				fetchLenderGroups();
			}

			setLenderGroupName("");
			setShowLenderGroupModal(false);
			customToast.success("Lender group created successfully!");
		}).catch((error) => {
			if (error.response) {
				customToast.error(error.response.data?.message);
			} else {
				customToast.error(error.message);
			}
		}).finally(() => {
			setCreateLenderGroupLoading(false);
		});
	}, [lenderGroupName, formData.lenderGroupIds, updateField]);

	// Update the validateRevenueField function to enforce only required fields
	const validateRevenueField = (name, value, formDatas) => {
		let error = "";

		if (name === "revenue_type_id" && value === "") {
			error = "Revenue type is required";
		} else if (
			name === "revenue_flat" &&
			value !== "" &&
			(isNaN(value) || Number(value) < 0)
		) {
			error = "Must be a positive number";
		} else if (
			name === "revenue_percentage" &&
			value !== "" &&
			(isNaN(value) || Number(value) < 0 || Number(value) > 100)
		) {
			error = "Must be between 0 and 100";
		}
		if (name.endsWith("_max")) {
			const minField = name.replace("_max", "_min");
			const minValue = formDatas[minField];

			if (
				value !== "" &&
				value !== null &&
				minValue !== "" &&
				Number(value) <= Number(minValue)
			) {
				error = "Max must be greater than Min";
			}
		}
		return error;
	};

	const isRevenueFormValid = () => {
		const { revenue_type_id, revenue_flat, revenue_percentage } = revenueFormData;

		// Check field-level errors
		const errors = {
			revenue_type_id: validateRevenueField('revenue_type_id', revenue_type_id, revenueFormData),
			revenue_flat: validateRevenueField('revenue_flat', revenue_flat, revenueFormData),
			revenue_percentage: validateRevenueField('revenue_percentage', revenue_percentage, revenueFormData),
		};

		const hasErrors = Object.values(errors).some(error => error !== '');

		// At least one of flat or percentage must be filled and valid
		const flatValid = revenue_flat !== '' && !isNaN(revenue_flat) && Number(revenue_flat) > 0;
		const percentageValid = revenue_percentage !== '' && !isNaN(revenue_percentage) && Number(revenue_percentage) > 0;

		const hasAtLeastOneRevenueField = flatValid || percentageValid;

		// All conditions must be satisfied
		return !hasErrors && revenue_type_id !== '' && hasAtLeastOneRevenueField;
	};

	// Update handleRevenueChange to include validation for revenue_flat and revenue_percentage together
	const handleRevenueChange = (e) => {
		const { name, value } = e.target;

		if (value && Number(value) < 0) return;

		setRevenueFormData({
			...revenueFormData,
			[name]: value
		});

		setRevenueErrors(prevErrors => {
			const updatedErrors = { ...prevErrors };

			// Validate the field being changed
			const error = validateRevenueField(name, value, {
				...revenueFormData,
				[name]: value // include the current field's new value
			});
			updatedErrors[name] = error;

			// If min is being changed, re-validate its corresponding max
			if (name.endsWith('_min')) {
				const maxField = name.replace('_min', '_max');
				const maxValue = revenueFormData[maxField];
				updatedErrors[maxField] = validateRevenueField(maxField, maxValue, {
					...revenueFormData,
					[name]: value
				});
			}

			return updatedErrors;
		});

	};

	// Update handleAddRevenue to set null for empty values
	const handleAddRevenue = async (e) => {
		e.preventDefault();
		setAddingRevenue(true);

		const normalizeNumber = (val) => val === '' || val === null || val === undefined ? null : Number(val);

		try {
			// Add lender ID to the form data and format payload according to API requirements
			const payload = {
				lender_id: lenderId,
				slab_disbursed_min: normalizeNumber(revenueFormData.slab_disbursed_min),
				slab_disbursed_max: normalizeNumber(revenueFormData.slab_disbursed_max),
				slab_number_min: normalizeNumber(revenueFormData.slab_number_min),
				slab_number_max: normalizeNumber(revenueFormData.slab_number_max),
				ats_min: normalizeNumber(revenueFormData.ats_min),
				ats_max: normalizeNumber(revenueFormData.ats_max),
				revenue_type_id: normalizeNumber(revenueFormData.revenue_type_id),
				revenue_flat: normalizeNumber(revenueFormData.revenue_flat),
				revenue_percent: normalizeNumber(revenueFormData.revenue_percentage),
				status: revenueFormData.status ? 1 : 0,
			};

			let response;

			if (editingRevenueId) {
				// Update existing revenue
				payload.id = editingRevenueId;
				response = await axios.post(`${endpoint}/api/lender-revenue/update`, payload);

				if (response.data.success) {
					// Update the revenue in the state
					setLenderRevenue(prevRevenue =>
						prevRevenue.map(rev =>
							rev.id === editingRevenueId ? {
								...payload,
								id: editingRevenueId,
								revenue_percentage: payload.revenue_percent
							} : rev
						)
					);

					customToast.success("Revenue updated successfully");
				} else {
					customToast.error(response.data.message || "Failed to update revenue");
				}
			} else {
				// Create new revenue
				response = await axios.post(`${endpoint}/api/lender-revenue/create`, payload);

				if (response.data.success) {
					// Create a new revenue object with the form data
					const newRevenue = {
						...payload,
						// Add any additional fields that might be set by the backend
						id: response.data.lenderRevenueItem.id, // Use the ID from response or fallback to timestamp
						revenue_percentage: payload.revenue_percent, // Map revenue_percent to revenue_percentage for UI display
					};

					// Append the new revenue to the existing state
					setLenderRevenue(prevRevenue => [...prevRevenue, newRevenue]);
					saveRevenueOrder([...lenderRevenue, newRevenue]);

					customToast.success("Revenue added successfully");
				} else {
					customToast.error(response.data.message || "Failed to add revenue");
				}
			}

			setShowRevenueModal(false);
			resetRevenueForm();
		} catch (error) {
			console.error('Error handling revenue:', error);
			customToast.error(error.response?.data?.message || `Failed to ${editingRevenueId ? 'update' : 'add'} revenue`);
		} finally {
			setAddingRevenue(false);
		}
	};

	// Native drag and drop handlers
	const handleDragStart = (e, index) => {
		setDraggedItem(index);
		// Set a transparent drag image
		const dragImg = document.createElement('div');
		dragImg.style.position = 'absolute';
		dragImg.style.top = '-9999px';
		document.body.appendChild(dragImg);
		e.dataTransfer.setDragImage(dragImg, 0, 0);
		e.dataTransfer.effectAllowed = 'move';
	};

	const handleDragOver = (e, index) => {
		e.preventDefault();
		setDraggedOverItem(index);
		e.dataTransfer.dropEffect = 'move';
	};

	const handleDragEnd = () => {
		setDraggedItem(null);
		setDraggedOverItem(null);
	};

	const handleDrop = async (e, index) => {
		e.preventDefault();
		// Ignore if dropped on itself
		if (draggedItem === index) {
			setDraggedItem(null);
			setDraggedOverItem(null);
			return;
		}

		// Clone array to avoid direct state mutation
		const items = [...lenderRevenue];
		// Store the dragged item
		const draggedItemContent = items[draggedItem];
		// Remove it from the array
		items.splice(draggedItem, 1);
		// Insert at the drop position
		items.splice(index, 0, draggedItemContent);

		// Update state
		setLenderRevenue(items);
		setDraggedItem(null);
		setDraggedOverItem(null);

		// Save the new order to the API
		await saveRevenueOrder(items);
	};

	// Function to save revenue order to API
	const saveRevenueOrder = async (items) => {
		setOrderLoading(true);
		try {
			const payload = {
				lender_id: lenderId,
				lender_revenue_ids: items.map(item => item.id)
			};

			const response = await axios.post(`${endpoint}/api/lender-revenue/set-order`, payload);

			if (response.data.success) {
				customToast.success("Revenue order updated");
			} else {
				customToast.error(response.data.message || "Failed to update order");
				// Optionally revert to original order on error
				fetchRevenue();
			}
		} catch (error) {
			console.error('Error updating revenue order:', error);
			customToast.error(error.response?.data?.message || "Failed to update order");
			// Optionally revert to original order on error
			fetchRevenue();
		} finally {
			setOrderLoading(false);
		}
	};

	// Add this function for deleting revenue entries
	const handleDeleteRevenue = async (id) => {
		// Open confirmation dialog
		setDeleteItemId(id);
		setDeleteConfirmOpen(true);
	};

	// Function to confirm and execute deletion
	const confirmDelete = async () => {
		if (!deleteItemId) return;

		setDeleteLoading(true);
		try {
			const response = await axios.post(`${endpoint}/api/lender-revenue/delete/${deleteItemId}`);

			if (response.data.success) {
				// Update local state by removing the deleted item
				setLenderRevenue(prevRevenue => prevRevenue.filter(item => item.id !== deleteItemId));
				customToast.success("Revenue entry deleted successfully");
			} else {
				customToast.error(response.data.message || "Failed to delete revenue entry");
			}
		} catch (error) {
			console.error('Error deleting revenue entry:', error);
			customToast.error(error.response?.data?.message || "Failed to delete revenue entry");
		} finally {
			setDeleteLoading(false);
			setDeleteConfirmOpen(false);
			setDeleteItemId(null);
		}
	};

	// Update resetRevenueForm to use default values
	const resetRevenueForm = () => {
		setRevenueFormData({
			slab_disbursed_min: '',
			slab_disbursed_max: '',
			slab_number_min: '',
			slab_number_max: '',
			ats_min: '',
			ats_max: '',
			revenue_type_id: '',
			revenue_flat: '',
			revenue_percentage: '',
			status: true
		});
		setRevenueErrors({
			slab_disbursed_min: '',
			slab_disbursed_max: '',
			slab_number_min: '',
			slab_number_max: '',
			ats_min: '',
			ats_max: '',
			revenue_type_id: '',
			revenue_flat: '',
			revenue_percentage: '',
			status: ''
		});
		setEditingRevenueId(null);
	};

	// Update handleEditRevenue to include status
	const handleEditRevenue = (revenue) => {
		setEditingRevenueId(revenue.id);
		setRevenueFormData({
			slab_disbursed_min: revenue.slab_disbursed_min,
			slab_disbursed_max: revenue.slab_disbursed_max,
			slab_number_min: revenue.slab_number_min,
			slab_number_max: revenue.slab_number_max,
			ats_min: revenue.ats_min,
			ats_max: revenue.ats_max,
			revenue_type_id: revenue.revenue_type_id,
			revenue_flat: revenue.revenue_flat || '',
			revenue_percentage: revenue.revenue_percent || '',
			status: revenue.status !== undefined ? revenue.status : true
		});
		setShowRevenueModal(true);
	};

	if (loading) {
		return (
			<Box sx={{ p: 3 }}>
				<Typography>Loading lender details...</Typography>
			</Box>
		);
	}

	return <>
		<Helmet>
			<title>Admin - Lenders Edit {app_title && `| ${app_title}`}</title>
		</Helmet>
		<Paper variant="outlined" sx={{ padding: 2, mb: 2 }}>
			<Box sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				mb: 3
			}}>
				<IconButton onClick={() => {
					navigate(-1)
				}}>
					<ArrowBack />
				</IconButton>
				<Typography variant="h6" color="secondary.main">Lender</Typography>
			</Box>

			{/* Lender Name Display */}
			<Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
				{lenderName}
			</Typography>

			<Divider sx={{ mb: 3 }} />

			{/* Lender Status */}
			<Grid container spacing={2}>
				<Grid item xs={12} md={2}>
					<FormControlLabel
						control={
							<Checkbox
								checked={formData.lenderStatus}
								onChange={handleCheckboxChange}
								name="lenderStatus"
							/>
						}
						label="Lender Status"
					/>
					{/* <FormControlLabel
						control={
							<Checkbox
								checked={formData.autoSubmission}
								onChange={handleCheckboxChange}
								name="autoSubmission"
							/>
						}
						label="Auto Submission"
					/> */}
				</Grid>
				
				{/* Priority */}
				<Grid item xs={6} md={2}>
					<TextField
						fullWidth
						label="Priority"
						name="priority"
						type="number"
						value={formData.priority}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>
			</Grid>
			{
				Number(originalData?.api) === 1 &&
				<Grid container spacing={2}>
					<Grid item xs={12} md={4}>
						<FormControlLabel
							control={
								<Checkbox
									checked={formData.autoSubmission}
									onChange={handleCheckboxChange}
									name="autoSubmission"
								/>
							}
							label="Auto Submission"
						/>
					</Grid>
				</Grid>
			}
			{/* Filter Criteria Section */}
			<Grid item xs={12}>
				<Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
					Filter Criteria
				</Typography>
				<Divider sx={{ mb: 2 }} />
			</Grid>
			<Grid container spacing={2}>
				{/* Income Range */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Income (min)"
						name="incomeMin"
						type="number"
						value={formData.incomeMin}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Income (max)"
						name="incomeMax"
						type="number"
						value={formData.incomeMax}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Age Range */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Age (min)"
						name="ageMin"
						type="number"
						value={formData.ageMin}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Age (max)"
						name="ageMax"
						type="number"
						value={formData.ageMax}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Ticket Class */}
				<Grid item xs={6} md={3}>
					<FormControl fullWidth size="small">
						<InputLabel id="ticket-class-label">Ticket Class</InputLabel>
						<Select
							labelId="ticket-class-label"
							name="ticketClass"
							value={formData.ticketClass}
							label="Ticket Class"
							onChange={handleSelectChange}
						>
							{ticketClass && ticketClass.map((option, idx) => (
								<MenuItem key={option.id || idx} value={option.id}>
									{option.value}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>

				{/* Credit Score Class */}
				<Grid item xs={6} md={3}>
					<FormControl fullWidth size="small">
						<InputLabel id="credit-score-label">Credit Score Class</InputLabel>
						<Select
							labelId="credit-score-label"
							name="creditScoreClass"
							value={formData.creditScoreClass}
							label="Credit Score Class"
							onChange={handleSelectChange}
						>
							{creditScoreClass && creditScoreClass.map((option, idx) => (
								<MenuItem key={option.id || idx} value={option.id}>
									{option.value}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>

				{/* New line for Employment Types */}
				<Grid item xs={12}>
					<Box sx={{ mt: 2 }}>
						<Typography variant="subtitle2" component="span" sx={{ mr: 2 }}>Employment Type</Typography>
						<FormGroup row>
							<FormControlLabel
								control={
									<Checkbox
										checked={formData.salaried}
										onChange={handleCheckboxChange}
										name="salaried"
										size="small"
									/>
								}
								label="Salaried"
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={formData.selfEmployed}
										onChange={handleCheckboxChange}
										name="selfEmployed"
										size="small"
									/>
								}
								label="Self Employed"
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={formData.business}
										onChange={handleCheckboxChange}
										name="business"
										size="small"
									/>
								}
								label="Business"
							/>
						</FormGroup>
					</Box>
				</Grid>
				

				{/* Loan Details Section */}
				<Grid item xs={12}>
					<Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
						KFS
					</Typography>
					<Divider sx={{ mb: 2 }} />
				</Grid>

				{/* Loan Amount */}
				<Grid item xs={6} md={3} sx={{ display: 'flex' , flexDirection: 'column', alignItems: 'center', gap: 1 }}>
					<TextField
						fullWidth
						name="kfs"
						label="KFS"
						InputLabelProps={{ shrink: true }}
						value={formData.kfs}
						variant="outlined"
						size="small"
						onChange={handleChange}
						onBlur={handleBlur}
					/>
					<Button 
						fullWidth 
						variant="contained" 
						color="primary"
						onClick={() => fileInputRef.current?.click()}
					>
						Upload File
					</Button>
					<input
						ref={fileInputRef}
						type="file"
						name="kfs"
						onChange={handleAttachmentChange}
						style={{ display: 'none' }}
					/>
				</Grid>

				{/* Loan Details Section */}
				<Grid item xs={12}>
					<Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
						Loan Details
					</Typography>
					<Divider sx={{ mb: 2 }} />
				</Grid>

				{/* Loan Amount */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Loan Amount Upto"
						name="loanAmountUpto"
						type="number"
						value={formData.loanAmountUpto}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Tenure */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Tenure (months)"
						name="tenure"
						value={formData.tenure}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Interest Rate - Full width on mobile */}
				<Grid item xs={12} md={3}>
					<TextField
						fullWidth
						label="Interest Rate"
						name="interestRate"
						value={formData.interestRate}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
						placeholder="e.g. 18% To 28%"
					/>
				</Grid>

				{/* Processing Fees */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Processing Fees"
						name="processingFees"
						value={formData.processingFees}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Monthly PR Min */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Monthly PR (min)"
						name="monthlyPRMin"
						type="number"
						value={formData.monthlyPRMin}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Monthly PR Max */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Monthly PR (max)"
						name="monthlyPRMax"
						type="number"
						value={formData.monthlyPRMax}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>
				<Grid item xs={12}>
					<Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
						Eligibility Criteria (text visible for partners)
					</Typography>
					<Divider sx={{ mb: 2 }} />
				</Grid>

				{/* Age */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Age"
						name="age_text"
						value={formData.age_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Employment */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Employment"
						name="employment_text"
						value={formData.employment_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Income */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Income"
						name="income_text"
						value={formData.income_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Min loan */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Min loan"
						name="min_loan_text"
						value={formData.min_loan_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Max loan */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Max loan"
						name="max_loan_text"
						value={formData.max_loan_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Cibil */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Cibil"
						name="cibil_text"
						value={formData.cibil_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Lender journey */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						label="Lender journey"
						name="lender_journey_text"
						value={formData.lender_journey_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* mp4 */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						name="mp4_text"
						label="Mp4"
						InputLabelProps={{ shrink: true }}
						value={formData.mp4_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* pptx */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						name="pptx_text"
						label="Pptx"
						value={formData.pptx_text}
						onChange={handleChange}
						onBlur={handleBlur}
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						size="small"
					/>
				</Grid>

				{/* Pdf */}
				<Grid item xs={6} md={3}>
					<TextField
						fullWidth
						name="pdf_text"
						label="Pdf"
						InputLabelProps={{ shrink: true }}
						value={formData.pdf_text}
						onChange={handleChange}
						onBlur={handleBlur}
						variant="outlined"
						size="small"
					/>
				</Grid>
			</Grid>


			{/* Special Offer Section */}
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
						Special Offer
					</Typography>
					<Divider sx={{ mb: 2 }} />
				</Grid>

				{/* Special Offer */}
				<Grid item xs={4} md={3}>
					<FormControlLabel
						control={
							<Checkbox
								checked={formData.specialOffer}
								onChange={handleCheckboxChange}
								name="specialOffer"
								size="small"
							/>
						}
						label="Special Offer"
					/>
				</Grid>

				{/* Special Offer Details - Only show if specialOffer is checked */}
				{formData.specialOffer && (
					<>
						<Grid item xs={8} md={3}>
							<TextField
								fullWidth
								label="Special Offer Text"
								name="soText"
								value={formData.soText}
								onChange={handleChange}
								onBlur={handleBlur}
								variant="outlined"
								size="small"
							/>
						</Grid>

						{/* Date fields on the same line */}
						<Grid item xs={6} md={3}>
							<TextField
								fullWidth
								label="Start Date"
								name="soDateStart"
								type="date"
								value={formData.soDateStart}
								onChange={handleDateChange}
								variant="outlined"
								size="small"
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
						<Grid item xs={6} md={3}>
							<TextField
								fullWidth
								label="End Date"
								name="soDateEnd"
								type="date"
								value={formData.soDateEnd}
								onChange={handleDateChange}
								variant="outlined"
								size="small"
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
					</>
				)}
			</Grid>


			{/* Commissions Section */}
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
						Commissions
					</Typography>
					<Divider sx={{ mb: 2 }} />
				</Grid>

				{/* Lender Group Multi-select */}
				<Grid item xs={12} md={3}>
					<Autocomplete
						multiple
						id="lender-group-autocomplete"
						options={[
							{ id: "create-new", name: "Create Group" },
							...lenderGroups
						]}
						getOptionLabel={(option) => option.name || ""}
						value={formData.lenderGroupIds.map(id =>
							lenderGroups.find(group => group.id == id) || { id, name: `Group ${id}` }
						)}
						onChange={handleMultiSelectChange}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="outlined"
								label="Group"
								size="small"
							/>
						)}
						renderTags={(value, getTagProps) =>
							value.map((option, index) => (
								<Chip
									label={option.name || `Group ${option.id}`}
									size="small"
									{...getTagProps({ index })}
								/>
							))
						}
						isOptionEqualToValue={(option, value) => option.id == value.id}
						size="small"
						renderOption={(props, option) => {
							if (option.id === "create-new") {
								return (
									<li {...props} style={{
										color: theme.palette.primary.main,
										fontWeight: 'bold',
										border: '1px solid',
										borderColor: theme.palette.border.main,
										borderRadius: '4px',
										margin: '4px',
										padding: '8px'
									}}>
										<AddIcon fontSize="small" style={{ marginRight: 8 }} />
										{option.name}
									</li>
								);
							}
							return (
								<li {...props} style={{
									border: '1px solid',
									borderColor: theme.palette.border.main,
									borderRadius: '4px',
									margin: '4px',
									padding: '8px'
								}}>
									{option.name}
								</li>
							);
						}}
					/>
				</Grid>
			</Grid>

			{/* Revenue Section */}
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Divider sx={{ mb: 2 }} />
				</Grid>

				<Grid item xs={12}>
					<Button
						variant="contained"
						color="primary"
						sx={{ mb: 2 }}
						onClick={() => setShowRevenueModal(true)}
						disabled={orderLoading}
					>Add Revenue</Button>
					<TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'border.main', mt: 2 }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell width="40px"></TableCell>
									<TableCell>Slab Disbured (Min)</TableCell>
									<TableCell>Slab Disbured (Max)</TableCell>
									<TableCell>Slab Number (Min)</TableCell>
									<TableCell>Slab Number (Max)</TableCell>
									<TableCell>ATS (Min)</TableCell>
									<TableCell>ATS (Max)</TableCell>
									<TableCell>Revenue Type</TableCell>
									<TableCell>Revenue Flat</TableCell>
									<TableCell>Revenue (%)</TableCell>
									<TableCell>Status</TableCell>
									<TableCell>Action</TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{revenueLoading && (
									<TableRow>
										<TableCell colSpan={11} align="center">Loading...</TableCell>
									</TableRow>
								)}

								{lenderRevenue.length === 0 && (
									<TableRow>
										<TableCell colSpan={11} align="center">No data found</TableCell>
									</TableRow>
								)}

								{lenderRevenue.map((revenue, index) => (
									<TableRow
										key={revenue.id || index}
										draggable
										onDragStart={(e) => handleDragStart(e, index)}
										onDragOver={(e) => handleDragOver(e, index)}
										onDragEnd={handleDragEnd}
										onDrop={(e) => handleDrop(e, index)}
										sx={{
											backgroundColor: draggedItem === index
												? 'rgba(0, 0, 0, 0.08)'
												: draggedOverItem === index
													? 'rgba(0, 120, 215, 0.1)'
													: 'inherit',
											opacity: draggedItem === index ? 0.5 : 1,
											'&:hover': {
												backgroundColor: 'rgba(0, 0, 0, 0.04)'
											},
											cursor: 'grab'
										}}
									>
										<TableCell width="40px">
											<DragIndicatorIcon color="action" />
										</TableCell>
										<TableCell>{revenue.slab_disbursed_min || "-"}</TableCell>
										<TableCell>{revenue.slab_disbursed_max || "-"}</TableCell>
										<TableCell>{revenue.slab_number_min || "-"}</TableCell>
										<TableCell>{revenue.slab_number_max || "-"}</TableCell>
										<TableCell>{revenue.ats_min || "-"}</TableCell>
										<TableCell>{revenue.ats_max || "-"}</TableCell>
										<TableCell>{revenueTypes.get(Number(revenue.revenue_type_id)) || "-"}</TableCell>
										<TableCell>{revenue.revenue_flat || "-"}</TableCell>
										<TableCell>{revenue.revenue_percent ? `${revenue.revenue_percent}%` : "-"}</TableCell>
										<TableCell>
											{revenue.status !== 0 ? (
												<ActiveIcon color="success" />
											) : (
												<InactiveIcon color="error" />
											)}
										</TableCell>
										<TableCell>
											<Box sx={{ display: 'flex' }}>
												<IconButton onClick={() => handleEditRevenue(revenue)}>
													<EditIcon />
												</IconButton>
												<IconButton onClick={() => handleDeleteRevenue(revenue.id)}>
													<DeleteIcon />
												</IconButton>
											</Box>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</Paper>



		{/* begin::Create lender group modal */}
		<Dialog
			open={showLenderGroupModal}
			scroll="paper"
			fullScreen={fullScreen}
			fullWidth
			TransitionComponent={Transition}
			component="form"
			autoComplete="off"
			sx={{
				zIndex: 9999
			}}
			onSubmit={createLenderGroup}
		>
			<DialogContent>
				<Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
					<Typography variant="h6" color="secondary.main">Add Lender Group</Typography>
					<IconButton onClick={() => setShowLenderGroupModal(false)}>
						<CloseIcon />
					</IconButton>
				</Grid>
				<Grid container justifyContent="center" spacing={3}>
					<Grid item xs={12}>
						<TextField
							margin="dense"
							required
							fullWidth
							label={t("Group Name")}
							name="lenderGroupName"
							value={lenderGroupName}
							onChange={(e) => {
								if (!(e.target.value.match(/^[a-zA-Z0-9\-_ ]*$/))) return;
								setLenderGroupName(e.target.value)
							}}
						>
						</TextField>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<LoadingButton
					loading={createLenderGroupLoading}
					color="secondary"
					variant="contained"
					size="large"
					fullWidth
					type="submit"
				>
					{t("Submit")}
				</LoadingButton>
			</DialogActions>
		</Dialog>
		{/* end::Create lender group modal */}

		{/* Add Revenue Modal - Updated */}
		<ThemeProvider theme={menuTheme}>
			<Dialog
				open={showRevenueModal}
				onClose={() => setShowRevenueModal(false)}
				fullWidth
				maxWidth="sm"
				component="form"
				onSubmit={handleAddRevenue}
				sx={{
					"& .MuiDialog-paper": {
						borderRadius: "16px"
					},
					"& .MuiDialogContent-root": {
						borderRadius: "16px"
					},
					"& .MuiPopover-root": {
						zIndex: 9999
					}
				}}
			>
				<DialogTitle>
					<Box display="flex" justifyContent="space-between" alignItems="center">
						<Typography variant="h6" fontWeight="bold">
							{editingRevenueId ? 'Edit Revenue' : 'Add Revenue'}
						</Typography>
						<IconButton onClick={() => {
							setShowRevenueModal(false);
							resetRevenueForm();
						}} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={2} sx={{ pt: 2 }}>

						<Grid item xs={4}>
							<FormControl fullWidth error={!!revenueErrors.revenue_type_id}>
								<InputLabel id="revenue-type-label">Revenue Type *</InputLabel>
								<Select
									labelId="revenue-type-label"
									name="revenue_type_id"
									value={revenueFormData.revenue_type_id}
									label="Revenue Type *"
									onChange={handleRevenueChange}
									disablePortal={false}
									MenuProps={{
										disablePortal: false,
										container: document.body,
										slotProps: {
											paper: {
												style: {
													zIndex: 10000
												}
											}
										}
									}}
								>
									{Array.from(revenueTypes.entries()).map(([id, name]) => (
										<MenuItem key={id} value={id}>
											{name}
										</MenuItem>
									))}
								</Select>
								{revenueErrors.revenue_type_id && (
									<Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5 }}>
										{revenueErrors.revenue_type_id}
									</Typography>
								)}
							</FormControl>
						</Grid>
						<Grid item xs={4}>
							<TextField
								fullWidth
								label="Revenue Flat"
								name="revenue_flat"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.revenue_flat}
								onChange={handleRevenueChange}
								placeholder="1000"
								error={!!revenueErrors.revenue_flat}
								helperText={revenueErrors.revenue_flat}
							/>
						</Grid>
						<Grid item xs={4}>
							<TextField
								fullWidth
								label="Revenue Percentage (%)"
								name="revenue_percentage"
								type="number"
								inputProps={{ min: 0, max: 100, step: 0.001 }}
								value={revenueFormData.revenue_percentage}
								onChange={handleRevenueChange}
								placeholder="3"
								error={!!revenueErrors.revenue_percentage}
								helperText={revenueErrors.revenue_percentage}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								fullWidth
								label="Slab Disbursed Min"
								name="slab_disbursed_min"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.slab_disbursed_min}
								onChange={handleRevenueChange}
								placeholder="0"
								error={!!revenueErrors.slab_disbursed_min}
								helperText={revenueErrors.slab_disbursed_min}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								fullWidth
								label="Slab Disbursed Max"
								name="slab_disbursed_max"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.slab_disbursed_max}
								onChange={handleRevenueChange}
								placeholder="100000"
								error={!!revenueErrors.slab_disbursed_max}
								helperText={revenueErrors.slab_disbursed_max}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								fullWidth
								label="Slab Number Min"
								name="slab_number_min"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.slab_number_min}
								onChange={handleRevenueChange}
								placeholder="0"
								error={!!revenueErrors.slab_number_min}
								helperText={revenueErrors.slab_number_min}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								fullWidth
								label="Slab Number Max"
								name="slab_number_max"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.slab_number_max}
								onChange={handleRevenueChange}
								placeholder="100"
								error={!!revenueErrors.slab_number_max}
								helperText={revenueErrors.slab_number_max}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								fullWidth
								label="ATS Min"
								name="ats_min"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.ats_min}
								onChange={handleRevenueChange}
								placeholder="0"
								error={!!revenueErrors.ats_min}
								helperText={revenueErrors.ats_min}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								fullWidth
								label="ATS Max"
								name="ats_max"
								type="number"
								inputProps={{ min: 0 }}
								value={revenueFormData.ats_max}
								onChange={handleRevenueChange}
								placeholder="100"
								error={!!revenueErrors.ats_max}
								helperText={revenueErrors.ats_max}
							/>
						</Grid>
						<Grid item xs={12}>
							<FormControlLabel
								control={
									<Checkbox
										checked={revenueFormData.status}
										onChange={(e) => setRevenueFormData({
											...revenueFormData,
											status: e.target.checked
										})}
										name="status"
									/>
								}
								label="Active"
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="caption">
								* Either Revenue Flat or Revenue Percentage is required
							</Typography>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions sx={{ p: 3 }}>
					<Button
						variant="contained"
						color="primary"
						type="submit"
						disabled={addingRevenue || !isRevenueFormValid()}
						fullWidth
						sx={{
							textTransform: "uppercase",
							fontWeight: "bold",
							py: 1.5,
							backgroundColor: "#0F0F67",
							"&:hover": {
								backgroundColor: "#0a0a4e"
							}
						}}
					>
						{addingRevenue ? "Submitting..." : (editingRevenueId ? "Update" : "Submit")}
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>

		{/* Revenue delete confirmation dialog */}
		<Dialog
			open={deleteConfirmOpen}
			onClose={() => setDeleteConfirmOpen(false)}
		>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<Typography>
					Are you sure you want to delete this revenue entry? This action cannot be undone.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => setDeleteConfirmOpen(false)}
					color="inherit"
				>
					Cancel
				</Button>
				<Button
					onClick={confirmDelete}
					color="error"
					variant="contained"
					disabled={deleteLoading}
				>
					{deleteLoading ? "Deleting..." : "Delete"}
				</Button>
			</DialogActions>
		</Dialog>
	</>
}
